// extracted by css-extract-rspack-plugin
export default {"account__top-right":"account__top-right-diUqbM","accountTopRight":"account__top-right-diUqbM","account__icon":"account__icon-KS0wbJ","accountIcon":"account__icon-KS0wbJ"};